/* eslint-env browser */
// Simplified fabric error fixer
(function () {
  'use strict';
  console.log('🔧 Fabric.js error suppression loaded');

  // Suppress stylesToArray errors
  if (typeof window.fabric !== 'undefined' && window.fabric && window.fabric.Textbox) {
    const originalToObject = window.fabric.Textbox.prototype.toObject;
    window.fabric.Textbox.prototype.toObject = function (props) {
      if (!this.styles) this.styles = {};
      return originalToObject.call(this, props);
    };
  }

  if (typeof window.fabric !== 'undefined' && window.fabric && window.fabric.IText) {
    const originalITextToObject = window.fabric.IText.prototype.toObject;
    window.fabric.IText.prototype.toObject = function (props) {
      if (!this.styles) this.styles = {};
      return originalITextToObject.call(this, props);
    };
  }

  console.log('✅ Fabric.js patches applied');
})();
